import '../Login/Login.scss';
import './Connect.scss';
import { ReactNode } from 'react';
import { Button } from '@Components/Button';
import { Appearance, Design, Size } from '@Components/designConstants';
import { ConsentInfo } from '@src/utils/auth/oauth-constants';

export const ConsentDecision = {
  ALLOW: 'allow',
  CANCEL: 'cancel'
} as const;
export type ConsentDecisionType = (typeof ConsentDecision)[keyof typeof ConsentDecision];

interface ConnectConsentViewProps {
  info: ConsentInfo;
  /** The decision being sent; both buttons are disabled while one is in flight. */
  submitting?: ConsentDecisionType;
  onAllow: () => void;
  onCancel: () => void;
}

// The strings in `info` come from the backend (the harness's registered name, its redirect host and
// the signed-in email) and are rendered as text only.
export const ConnectConsentView = ({
  info,
  submitting,
  onAllow,
  onCancel
}: ConnectConsentViewProps): ReactNode => (
  <div className='bpm-login connect-page' data-testid='connect-consent'>
    <div className='bpm-login-inner'>
      <div className='login-form'>
        <h2 className='connect-heading'>
          Connect {info.harness} to Blisspoint as {info.email}?
        </h2>
        <p className='connect-detail'>
          If you allow this, you will be sent back to <strong>{info.redirectHost}</strong>.
        </p>
        <div className='connect-actions'>
          <Button
            size={Size.LG}
            disabled={submitting !== undefined}
            loading={submitting === ConsentDecision.ALLOW}
            onClick={onAllow}
            data-testid='connect-allow'
          >
            Allow
          </Button>
          <Button
            size={Size.LG}
            appearance={Appearance.OUTLINED}
            design={Design.NEUTRAL}
            disabled={submitting !== undefined}
            loading={submitting === ConsentDecision.CANCEL}
            onClick={onCancel}
            data-testid='connect-cancel'
          >
            Cancel
          </Button>
        </div>
      </div>
    </div>
  </div>
);
